import React, { useEffect, useState } from 'react'
import './styles.css'
import SvgIcon, { iconList } from '../../../share/components/iconSVG/index'
import { currencyFormat } from '../../../../utils'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { CircularProgress } from '@mui/material'

const CardHotelResult = ({ data }) => {

  const navigate = useNavigate()
 
  const [dataHot, setDataHot] = useState([])
  const [loadingViewRoom, setLoadingViewRoom] = useState(false)
  const stars = [];
  for (let i = 0; i < Number(data.cat); i++) {
    stars.push(<SvgIcon key={i} name={iconList.IconStar} color={'#ffff00'} size={20} />);
  }

  function formatterText(frase) {
    // Dividir la frase en palabras individuales
    let palabras = frase.toLowerCase().split(' ');

    // Capitalizar la primera letra de cada palabra
    for (let i = 0; i < palabras.length; i++) {
      palabras[i] = palabras[i].charAt(0).toUpperCase() + palabras[i].slice(1);
    }

    // Unir las palabras en una sola frase
    let resultado = palabras.join(' ');

    return resultado;
  }


  const findRoomPrice = data.res.pax[0].hab.reduce((minObjeto, objeto) => {
    if (objeto.reg[0]["@attributes"].prr < minObjeto.reg[0]["@attributes"].prr) {
      return objeto;
    } else {
      return minObjeto;
    }
  });

  function sumPorcentage(num) {
    const numero = Number(num)
    const porcentaje = numero * 0.35;
    const resultado = numero + porcentaje;
    const resultadoRedondeado = Math.round(resultado * 100) / 100;
    return resultadoRedondeado;
  
  }

  const detailHotelView = ()=>{
    setLoadingViewRoom(true)
    axios.post('https://travelflight.pdtcomunicaciones.com/api/restel/information',{
        hotel: data.cod
    })
    .then(res=>{
        setDataHot(res.data.hotel.parametros.hotel) 
        setLoadingViewRoom(false)
        console.log(res.data.hotel.parametros.hotel)
        navigate(`/hotel/${data.nom}`, {
          state: {
            dataHab: data,
            dataHot: res.data.hotel.parametros.hotel
          }
        })
    })
    .catch(err=>{
      console.log(err)
    })
  
  }

  return (
    <div className='card-result-hotel'>
      <div className='contain-porcentage-desc'>
        <span>
          -35%
        </span>
      </div>
      <div className='contain-img-hotel-result'>
        <img className='img-hotel-result' src={data.foto} alt="" />
        <div className="service-room-include">
          <SvgIcon name={iconList.IconFood} color={'#ffffff'} size={30} />
          <span>{findRoomPrice.reg[0]["@attributes"].cod}</span>
        </div>
      </div>

      <div className='contain-info-result-hotels'>
        <section className='contain-info-hotel-card'>

          <h2>{data.nom}</h2>
          <p className='dir-hotel-card'>{formatterText(data.dir)}</p>
          <div className='star-hotel-card'>
            <span>
              {Number(data.cat).toFixed(1)}
            </span>
            <div>
              {stars}
            </div>
          </div>
          <div className='card-hotel-habitacion'>
            <p >
              <SvgIcon name={iconList.IconRestRoom} color={'#004274'} size={30} />
              {findRoomPrice["@attributes"].desc}
            </p>
          </div>
        </section>
        <section className='contain-price-hotel-card'>
          <div>
            <p className='price-normal-hotel-card'>
              {sumPorcentage(findRoomPrice.reg[0]["@attributes"].prr)}
            </p>
            <p className='price-descount-hotel-card'>
              {currencyFormat(findRoomPrice.reg[0]["@attributes"].prr).total}
            </p>
            <p className='taza-impuestos'>
              Incluye impuestos, tasas y cargos excepto el IVA
            </p>
            <p className='what-include'>¿Qué incluye este precio?</p>
          </div>
          <div className='button-detail-habitaciones'>
            <button onClick={detailHotelView} style={{ PointerEvent: loadingViewRoom ? 'none' : 'auto', opacity: loadingViewRoom ? 0.5 : 1 }}>
              {
                loadingViewRoom === true ?
                <CircularProgress size={25}/>
                :
                "Ver Habitaciones"
              }
              
            </button>
          </div>
        </section>
      </div>
    </div>
  )
}

export default CardHotelResult